import { Component, Input, OnChanges, OnDestroy, signal } from '@angular/core'

/** Creamos y liberamos el object URL usado para mostrar una miniatura local. */
@Component({
  selector: 'app-mini-foto-blob',
  standalone: true,
  template: `@if (url()) {
    <img [src]="url()" [alt]="alt" [class]="className" />
  }`,
})
export class MiniFotoBlobComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) blob!: Blob
  @Input({ required: true }) alt = ''
  @Input({ required: true }) className = ''

  readonly url = signal<string | undefined>(undefined)
  private urlActual?: string

  ngOnChanges(): void {
    if (this.urlActual) URL.revokeObjectURL(this.urlActual)
    // Un blob vacio significa que la foto ya se sincronizo hace tiempo y su
    // copia local se limpio (ver limpiarBlobsSincronizadosAntiguos en db.ts)
    // — la real vive en Supabase. Mostramos nada en vez de un icono roto.
    if (this.blob.size === 0) {
      this.urlActual = undefined
      this.url.set(undefined)
      return
    }
    this.urlActual = URL.createObjectURL(this.blob)
    this.url.set(this.urlActual)
  }

  ngOnDestroy(): void {
    if (this.urlActual) URL.revokeObjectURL(this.urlActual)
  }
}
